import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '@/shared/components/layout/PageHeader'
import { IncidentClientVisibilityFeature } from '@/features/incident-client-visibility/IncidentClientVisibilityFeature'

function IncidentVisibilityPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Incident Visibility" />
      <IncidentClientVisibilityFeature />
    </div>
  )
}

export const Route = createFileRoute('/settings/incident-visibility')({
  component: IncidentVisibilityPage,
  staticData: { authorize: true },
})
